/**
 * Shared React Context instance for the global app state.
 */

import { createContext } from 'react';
import type { Repository, SetupProgress, AnalysisData } from '../types';

export interface DemoState {
  isActive: boolean;
  preventNetworkRequests: boolean;
  mockDataLoaded: boolean;
  demoRepository: Repository | null;
}

export interface AppContextValue {
  selectedRepository: Repository | null;
  setSelectedRepository: (repo: Repository) => void;
  setupProgress: SetupProgress;
  setSetupProgress: (progress: SetupProgress) => void;
  analysisData: AnalysisData | null;
  setAnalysisData: (data: AnalysisData) => void;
  isDemoMode: boolean;
  setDemoMode: (isDemo: boolean) => void;
  flowType: 'repository' | 'upload' | 'demo' | null;
  setFlowType: (type: 'repository' | 'upload' | 'demo' | null) => void;
  demoState: DemoState;
  resetDemoState: () => void;
  ensureDemoMode: () => void;
}

export const AppContext = createContext<AppContextValue | undefined>(undefined);
